import { CouponType } from "./coupon";
import { UserPlan } from "./user";

export enum GameId {
  WHEEL = 'wheel',
  BOX = 'boxes',
  LUCKY = 'lucky',
}

export type GameResult = {
  win: boolean;
  coupon?: {
    wixCouponId?: string;
    code?: string;
    name: string;
    description?: string;
    uuid?: string;
    type: CouponType;
    link?: string;
    linkText?: string;
  };
  couponIndex?: number;
};

export type UploadFileDto = FormData;

export type UploadFileResult = {
  url: string;
};

export type CreatePaymentLinkDto = {
  tarif: UserPlan;
  period: 'monthly' | 'yearly';
};
